import FinanceDashboard from "../components/Finance/FinanceDashboard";

function FinancePage() {
    return (
        <FinanceDashboard />
    )
}

export default FinancePage;